import type { Visit } from "@/app/services/generated/visitService";
import {
  VisitReadOnly,
  visitService,
} from "@/app/services/generated/visitService";
import Guid from "@/app/types/common/guid";
import type { AddVisitEvent } from "@/components/pages/distribution/dialogs/AddVisitDialog.vue";
import { showModalDialog } from "@/components/platform/common/showModalDialog";
import AddVisitDialog from "@/components/pages/distribution/dialogs/AddVisitDialog.vue";
import { wrapLoading } from "@/components/composables/componentTools";
import type { LocalDate } from "@js-joda/core";

export async function duplicateVisitWithDialog(visit: Visit) {
  const duplicatedVisit = visit.clone();
  duplicatedVisit.id = Guid.create();
  duplicatedVisit.version = 0;
  duplicatedVisit.readOnly = new VisitReadOnly();
  const result = await showModalDialog<AddVisitEvent, typeof AddVisitDialog>(
    AddVisitDialog,
    {
      props: {
        visitToEdit: duplicatedVisit,
        businessId: visit.outletId,
      },
    }
  );
  if (result.wasSuccessful && result.value) {
    await wrapLoading(async () => {
      await visitService.saveVisit(result.value!.visit);
    });
    return result.value!.visit;
  }
  return null;
}

export async function addVisitWithDialog(options: {
  businessId?: Guid | null;
  date?: LocalDate | null;
  reason?: string | null;
}) {
  const result = await showModalDialog<AddVisitEvent, typeof AddVisitDialog>(
    AddVisitDialog,
    {
      props: {
        businessId: options.businessId,
        date: options.date,
        reason: options.reason,
      },
    }
  );
  if (result.wasSuccessful && result.value) {
    await wrapLoading(async () => {
      await visitService.saveVisit(result.value!.visit);
    });
    return result.value!.visit;
  }
  return null;
}
